import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

const IllustrativeIcon = {
  title: 'Components/Icon/Illustrative Icon',
  component: 'a1-illustrative-icon',
  argTypes: {
    size: {
      // Rearrange the order of the options
      options: ['l', 'xl'],
      control: { type: 'select' },
    },
  },
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component:
          'A list of available icons can be found [here](https://ndbx.azurewebsites.net/allianz-icons/prod/index.html).',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-illustrative-icon';

const Template = (args: Components.A1IllustrativeIcon): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Default: Story<Components.A1IllustrativeIcon> = Template.bind({});

export const Inverse: Story<Components.A1IllustrativeIcon> = Template.bind({});
Inverse.args = {
  inverse: true,
};
Inverse.parameters = {
  backgrounds: { default: 'Inverse' },
};

export const Disabled: Story<Components.A1IllustrativeIcon> = Template.bind({});
Disabled.args = {
  disabled: true,
};

export const DisabledInverse: Story<Components.A1IllustrativeIcon> = Template.bind({});
DisabledInverse.args = {
  disabled: true,
  inverse: true,
};
DisabledInverse.parameters = {
  backgrounds: { default: 'Inverse' },
};

export const ContainedDefault: Story<Components.A1IllustrativeIcon> = Template.bind({});
ContainedDefault.args = {
  contained: true,
  containedType: 'default',
};
ContainedDefault.parameters = {
  backgrounds: { default: 'Emphasis' },
};

export const ContainedDefaultDisabled: Story<Components.A1IllustrativeIcon> = Template.bind({});
ContainedDefaultDisabled.args = {
  contained: true,
  containedType: 'default',
  disabled: true,
};

export const ContainedDefaultInverse: Story<Components.A1IllustrativeIcon> = Template.bind({});
ContainedDefaultInverse.args = {
  contained: true,
  containedType: 'default',
  inverse: true,
};
ContainedDefaultInverse.parameters = {
  backgrounds: { default: 'Emphasis' },
};

export const ContainedDefaultInverseDisabled: Story<Components.A1IllustrativeIcon> = Template.bind({});
ContainedDefaultInverseDisabled.args = {
  contained: true,
  containedType: 'default',
  inverse: true,
  disabled: true,
};
ContainedDefaultInverseDisabled.parameters = {
  backgrounds: { default: 'Inverse' },
};

export const ContainedEmphasis: Story<Components.A1IllustrativeIcon> = Template.bind({});
ContainedEmphasis.args = {
  contained: true,
  containedType: 'emphasis',
};

export const ContainedEmphasisDisabled: Story<Components.A1IllustrativeIcon> = Template.bind({});
ContainedEmphasisDisabled.args = {
  contained: true,
  containedType: 'emphasis',
  disabled: true,
};

export const ContainedEmphasisInverse: Story<Components.A1IllustrativeIcon> = Template.bind({});
ContainedEmphasisInverse.args = {
  contained: true,
  containedType: 'emphasis',
  inverse: true,
};
ContainedEmphasisInverse.parameters = {
  backgrounds: { default: 'Emphasis' },
};

export const ContainedEmphasisInverseDisabled: Story<Components.A1IllustrativeIcon> = Template.bind({});
ContainedEmphasisInverseDisabled.args = {
  contained: true,
  containedType: 'emphasis',
  inverse: true,
  disabled: true,
};
ContainedEmphasisInverseDisabled.parameters = {
  backgrounds: { default: 'Inverse' },
};

export default IllustrativeIcon;
